import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import axios from 'axios'
import en from './locale/en'
import sv from './locale/sv'
import CrmContentPlugin from 'vue-gr8crm-content'

axios.defaults.baseURL = process.env.VUE_APP_API

Vue.prototype.$http = axios

Vue.config.productionTip = false

Vue.use(Vuetify)

const vuetifyOpts = {
  theme: {
    themes: {
      light: {
        primary: '#1b3ab5',
        secondary: '#f9b936',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FB8C00'
      },
      dark: {
        primary: '#2196F3',
        secondary: '#424242',
        accent: '#FF4081',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FB8C00'
      }
    }
  },
  lang: {
    locales: { en, sv },
    current: navigator.language.substring(0, 2)
  }
}

router.beforeEach((to, from, next) => {

  if (to.params.tenant) {
    store.commit('setTenant', to.params.tenant)
  }

  next()
})

Vue.use(CrmContentPlugin, { store, router })

new Vue({
  vuetify: new Vuetify(vuetifyOpts),
  router,
  store,
  render: h => h(App)
}).$mount('#app')
